import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BankOutlined, MailOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import ClientCompaniesDrawer from "@/components/OrderDetail/ClientCompaniesDrawer";
import { getRootStore } from "@/stores/RootStore";
import { B2B_ENABLED } from "@/utils/featureFlags";
import styles from "@/styles/OrderDetail/ClientContactCard.module.less";
const { Text } = Typography;
/**
 * Format a Russian phone number for display and tel: link.
 * Mirrors the formatPhone utility in OrderCardCompact.
 */
const formatPhone = (raw) => {
    const digits = raw.replace(/\D/g, "");
    let local = null;
    if (digits.length === 11 && (digits[0] === "7" || digits[0] === "8")) {
        local = digits.slice(1);
    }
    else if (digits.length === 10) {
        local = digits;
    }
    if (local) {
        const display = `+7 ${local.slice(0, 3)} ${local.slice(3, 6)}-${local.slice(6, 8)}-${local.slice(8, 10)}`;
        return { display, tel: `+7${local}` };
    }
    return {
        display: raw,
        tel: raw.trim().startsWith("+") ? `+${digits}` : digits,
    };
};
const ClientContactCard = observer(() => {
    const { orderDetailStore } = getRootStore();
    const client = orderDetailStore.client;
    // FR-006 (UC1117): «Компании клиента» — только при REACT_APP_B2B_ENABLED (BR-UI-01)
    const [companiesOpen, setCompaniesOpen] = useState(false);
    if (!client) {
        return (_jsx("div", { className: styles.card, children: _jsx(Text, { type: "secondary", className: styles.empty, children: "\u041A\u043B\u0438\u0435\u043D\u0442 \u043D\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D" }) }));
    }
    const fullName = [client.firstName, client.lastName].filter(Boolean).join(" ");
    const phone = client.phone?.trim() || "";
    const formattedPhone = phone ? formatPhone(phone) : null;
    return (_jsxs("div", { className: styles.card, children: [_jsxs("div", { className: styles.header, children: [_jsx(UserOutlined, { className: styles.headerIcon }), _jsx(Text, { strong: true, className: styles.name, children: fullName || "Имя не указано" })] }), _jsxs(Text, { type: "secondary", className: styles.clientId, children: ["ID: ", client.id] }), _jsxs("div", { className: styles.contacts, children: [formattedPhone && (_jsxs("a", { href: `tel:${formattedPhone.tel}`, className: styles.contactRow, children: [_jsx(PhoneOutlined, { className: styles.contactIcon }), _jsx("span", { children: formattedPhone.display })] })), client.email && (_jsxs("a", { href: `mailto:${client.email}`, className: styles.contactRow, children: [_jsx(MailOutlined, { className: styles.contactIcon }), _jsx("span", { children: client.email })] }))] }), B2B_ENABLED ? (_jsxs(_Fragment, { children: [_jsx(Button, { size: "small", icon: _jsx(BankOutlined, {}), className: styles.companiesButton, onClick: () => setCompaniesOpen(true), children: "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u043A\u043B\u0438\u0435\u043D\u0442\u0430" }), _jsx(ClientCompaniesDrawer, { client: client, open: companiesOpen, onClose: () => setCompaniesOpen(false) })] })) : null] }));
});
ClientContactCard.displayName = "ClientContactCard";
export default ClientContactCard;
